import { render, staticRenderFns } from "./SmallChartPanel.vue?vue&type=template&id=0ec97a27&lang=pug&"
import script from "./SmallChartPanel.vue?vue&type=script&lang=ts&"
export * from "./SmallChartPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SmallChartPanel.vue?vue&type=style&index=0&id=0ec97a27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports